module.exports = __webpack_public_path__ + "img/right-arrow.cdb45979.svg";